const ActionsType = {
  SET_CURRENT_USER: "SET_CURRENT_USER",
  SET_CURRENT_TOPIC: "SET_CURRENT_TOPIC",
  SET_LESSON: "SET_LESSON",
  SET_BALANCE: "SET_BALANCE",
}

export default ActionsType
